import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/auth';

// Live state of the founding-member offer (slots left, deadline, price).
// Server-enforced; this only displays it. null until the first answer arrives.
export const useFoundingOffer = () => {
  const [offer, setOffer] = useState(null);
  const load = useCallback(async () => {
    try {
      const res = await api.get('/offers/founding');
      setOffer(res.data);
    } catch {
      // keep the last good value; the price at checkout is decided by the server anyway
    }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('dl-config-changed', load);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('dl-config-changed', load);
    };
  }, [load]);
  return offer;
};

export const formatEnd = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' }) : '';
